'use client';

import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import STYLE from './Copyright.module.scss';

interface CopyrightPropType {
    isBuyer: boolean;
}

export const Copyright: React.FC<CopyrightPropType> = (props) => {
    const { isBuyer } = props;

    return (
        <div className={clsx(STYLE.copyright, { 'is-editing': !isBuyer })}>
            <Link href={process.env.NEXT_PUBLIC_TECH_ORIGIN || '/'} target="_blank">
                Powered By Pinzap
            </Link>
        </div>
    );
};
